import { render } from "./ReferDownloadPage.vue?vue&type=template&id=439fbfba&scoped=true"
import script from "./ReferDownloadPage.vue?vue&type=script&lang=js"
export * from "./ReferDownloadPage.vue?vue&type=script&lang=js"

import "./ReferDownloadPage.vue?vue&type=style&index=0&id=439fbfba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439fbfba"]])

export default __exports__